export default __webpack_public_path__ + "static/media/cinde.4644eb1b.png";